import { render, staticRenderFns } from "./BaseLoading.vue?vue&type=template&id=897793be&"
import script from "./BaseLoading.vue?vue&type=script&lang=js&"
export * from "./BaseLoading.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports